import React, { useState } from 'react';
import { RadiusIcon } from '@rsos/assets/icons';
import usePortalType from '@rsos/utils/usePortalType';
import HoveredButton from '../HoveredButton';
import UncertaintyConfidence from './UncertaintyConfidence';
import { handleCopy } from './helpers/handleCopy';
import {
  RowBox,
  LeftText,
  MiddleText,
  CopyColumnBox,
  IconWrapper,
} from './styles/common.styles';

const Uncertainty = ({
  uncertaintyRadius,
  confidence,
  isHoverable,
  irpVersion,
  payloadID,
  requestID,
  secondary,
}) => {
  const { portalType } = usePortalType();

  const [isCopied, setIsCopied] = useState();
  if (!uncertaintyRadius) return null;

  const uncertaintyValue =
    uncertaintyRadius < 0
      ? `Unknown`
      : `${Number(uncertaintyRadius).toFixed(1)}m`;

  const confidenceValue = confidence ? `, Confidence: ${confidence}` : '';

  const onClick = () => {
    handleCopy({
      value: `Uncertainty Radius: ${uncertaintyValue} ${confidenceValue}`,
      name: 'Uncertainty Radius and Confidence',
      irpVersion,
      payloadID,
      requestID,
      portalType,
      onStart: () => {
        setIsCopied(true);
      },
      onEnd: () => {
        setIsCopied(false);
      },
    });
  };

  return (
    <RowBox isHoverable={isHoverable} px={2} copied={isCopied}>
      <RowBox>
        <RowBox px={2}>
          <IconWrapper>
            <RadiusIcon width={secondary && 10} height={secondary && 10} />
          </IconWrapper>
        </RowBox>
        <CopyColumnBox>
          <RowBox data-name="uncertainty">
            <LeftText secondary={secondary}>Uncertainty Radius:&nbsp;</LeftText>
            <MiddleText secondary={secondary} data-name="uncertainty-text">
              {uncertaintyValue}
            </MiddleText>
          </RowBox>
          <UncertaintyConfidence confidence={confidence} />
        </CopyColumnBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon isCopied={isCopied} />
      )}
    </RowBox>
  );
};

export default Uncertainty;
